import { cn } from '@/lib/utils';
import { DialogContent } from '@music-vine/cadence/ui';
import type { Dialog as DialogPrimitive } from 'radix-ui';
export const DialogContentBoards = ({
  children,
  className,
  ...props
}: DialogPrimitive.DialogContentProps) => <DialogContent className={cn('min-h-40 w-[90%] xs:w-[400px] gap-4 rounded-xl border-gray-100 border-solid bg-white p-5 shadow-md dark:border-1 dark:border-gray-800 dark:bg-gray-900 dark:shadow-xl', className)} {...props} data-sentry-element="DialogContent" data-sentry-component="DialogContentBoards" data-sentry-source-file="dialog-partials.tsx">
    {children}
  </DialogContent>;
export const DialogHeaderBoards = ({
  children,
  className,
  ...props
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={cn('font-heading font-semibold text-xl leading-snug tracking-tight dark:text-white', className)} {...props} data-sentry-component="DialogHeaderBoards" data-sentry-source-file="dialog-partials.tsx">
    {children}
  </div>;